/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLockOpen = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M12 2a3 3 0 0 0-3 3v4.929h11v12.06H4V9.928h3V5a5 5 0 0 1 10 0v1h-2V5a3 3 0 0 0-3-3zm-6 9.929v8.06h12v-8.06z" />
        <path d="M10 17v-2h4v2z" />
      </g>
    </g>
  </Icon>
);
export { SvgLockOpen as LockOpen };
